module.exports = __webpack_public_path__ + "296761481f82e9034e4cc2696bf03d24.pdf";